import React, { Component } from 'react';
import { connect, router } from 'dva';
import { LockOutlined, UserOutlined, PictureOutlined } from '@ant-design/icons';
import { Layout, Button, Input, Spin, Form, Row, Col } from 'antd';
import logoImg from 'assets/images/logo2.png';
import './index.less';

import Config from '../../../config';

const { Link } = router;
const { Content } = Layout;
const FormItem = Form.Item;

@connect(({ login, loading }) => ({
    login,
    loading: loading.models.login
}))
export default class Login extends Component {

    state = {
        captcha_url: "",
        timestamp: new Date() - 0
    };

    componentDidMount() {

        this.freshCaptcha();
    }

    handleSubmit = values => {
        const { dispatch } = this.props;

        values["timestamp"] = this.state.timestamp;

        dispatch({
            type: 'login/login',
            payload: values
        }).then((ret) => {

            if (!ret) {
                this.freshCaptcha();
            }
        });
    };

    freshCaptcha = () => {

        this.setState({
            captcha_url: Config.request.prefix + "/admin/captcha_code?timestamp=" + this.state.timestamp + "&t=" + Math.random()
        });
    }

    render() {
        const { loading } = this.props;

        let { captcha_url } = this.state;

        return (
            <Layout className="full-layout login-page">
                <Content>
                    <Spin tip="登录中..." spinning={!!loading}>
                        <Form onFinish={this.handleSubmit} className="login-form">
                            <div className="user-img">
                                <img src={logoImg} alt="logo" />
                                <b>TimeChart</b>
                                <span> - Admin</span>
                            </div>
                            <FormItem name="username" rules={[{ required: true, message: '请输入您的用户名' }]}>
                                <Input
                                    size="large"
                                    prefix={<UserOutlined />}
                                    placeholder="请输入登录用户名" />
                            </FormItem>
                            <FormItem name="password" rules={[{ required: true, message: '请输入您的密码' }]}>
                                <Input
                                    size="large"
                                    prefix={<LockOutlined />}
                                    type="password"
                                    placeholder="请输入密码" />
                            </FormItem>

                            <Form.Item>
                                <Row gutter={8}>
                                    <Col span={16}>
                                        <FormItem name="captcha_code" rules={[{ required: true, message: '请输入您的密码' }]}>
                                            <Input
                                                size="large"
                                                prefix={<PictureOutlined />}
                                                placeholder="请输入图形验证码" />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <img onClick={this.freshCaptcha} className="captcha-code" src={captcha_url} />
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                className="login-form-button">
                                登录
                            </Button>
                            <Link className="login-form-forgot" to="#">
                                OpenID登录 ->
                            </Link>
                        </Form>
                    </Spin>
                </Content>
            </Layout>
        );
    }
}
